import * as React from 'react';
import { GetHandleProps, SliderItem } from 'react-compound-slider';

export type PrepareLabelCallback = (value: number) => string;

export interface HandleProps {
    getHandleProps: GetHandleProps
    handle: SliderItem
    label: string
}

export class Handle extends React.PureComponent<HandleProps> {
    public render() {
        const props = this.props;
        const handle = props.handle;

        return <div
            className="pf-range-handle"
            style={{left: `${handle.percent}%`}}
            {...props.getHandleProps(handle.id)}
        >
            <div className="pf-range-handle-caption">{props.label}</div>
        </div>;
    }
}
